import type { ReactNode } from "react";

/** Renders a field label, coloring a trailing required asterisk with text-danger. */
export function renderFieldLabel(label: string): ReactNode {
  const required = /\s*\*$/.test(label);
  const text = label.replace(/\s*\*$/, "").trimEnd();

  return (
    <span className="text-sm font-medium text-ink">
      {text}
      {required ? <span className="text-danger"> *</span> : null}
    </span>
  );
}
